import { render, staticRenderFns } from "./ProductionDetails.vue?vue&type=template&id=4ab90b4c&"
import script from "./ProductionDetails.vue?vue&type=script&lang=js&"
export * from "./ProductionDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports